import { Component } from '@angular/core'
import { $app } from '@app/app.service'
import { Subscription } from 'rxjs'

@Component({
   selector: 'layout-app-basic',
   template: '',
})
export class AppBasicLayout {
   console: boolean = $app.core.modeDevel
   logPrefix: string = '@layout - ' + this.constructor.name

   $app = $app //for use in template

   listener: Subscription

   ngOnDestroy(): void {
      this.listener?.unsubscribe()
   }
}

